import { IGameState } from 'State/Game/IGameState';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import { ICardStateTaskData } from '../ICardState';
import BaseCardBehavior from './BaseCardBehavior';

export default class PlinkoCardBehavior extends BaseCardBehavior {
    protected addMatchTaskToQueue(state: IGameState, taskData: Partial<ICardStateTaskData>): IGameState {
        // Queue receive task
        let cardsState = { ...state.levelState.cardsState };
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.RECEIVE_PLINKO_CARD,
            cards: [this.cardID],
        });
        return CardStateHelper.updateGameState(state, cardsState);
    }
}
